import { render, staticRenderFns } from "./joinForm.vue?vue&type=template&id=15a5cbf1&scoped=true"
import script from "./joinForm.vue?vue&type=script&lang=js"
export * from "./joinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a5cbf1",
  null
  
)

export default component.exports